<div class="card m-0 bg-transparent">
  <div class="card-body">


    <div class="row">

      <div class="col-12">
        <label
          for="text-color"
          class="offcanvas-header-text w-100"
          style="text-align: left"
        >
        {{   'GENERALS.HERIZONTALSPACE' | translate}}
        </label>
        <div
          class="input-group offcanvas-border-primary border rounded-2"
          title="Using format option"
        >
        <input type="range" [value]="button?.button_page_data?.border_margin_start" class="form-range border border-0 " min="1" max="5" step="1" id="ms" #ms (change)="changeMs(ms.value)">

        </div>
      </div>

  </div>
  </div>
</div>
